import { defineComponent as b, ref as S, computed as n, toRef as d, resolveComponent as k, openBlock as f, createElementBlock as C, normalizeClass as a, renderSlot as c, createBlock as O, withCtx as T, createElementVNode as B, createTextVNode as P, toDisplayString as E, createCommentVNode as $ } from "vue";
import { usePopoverState as h } from "@onereach/ui-components-common/hooks";
import { a as o, O as N } from "./OrPopover-DbygLPtT.mjs";
import "@onereach/ui-components-common/utils";
import { _ as R } from "./_plugin-vue_export-helper-CHgC5LLL.mjs";
const V = [
  // Layout
  "layout-inline-row",
  // Typography
  "leading-[0]"
], w = [
  // Layout
  "layout-inline-column",
  // Shape
  "rounded-sm",
  // Spacing
  "mx-sm",
  "my-sm",
  "px-sm",
  "py-xs",
  // Typography
  "typography-caption-regular",
  // Theme
  "theme-foreground-on-surface-inverse",
  "dark:theme-foreground-on-surface-inverse-dark",
  "theme-background-surface-inverse",
  "dark:theme-background-surface-inverse-dark"
], L = {
  [o.Top]: [
    // Spacing
    "mb-0"
  ],
  [o.TopStart]: [
    // Spacing
    "mb-0",
    "ml-0"
  ],
  [o.TopEnd]: [
    // Spacing
    "mb-0",
    "mr-0"
  ],
  [o.Bottom]: [
    // Spacing
    "mt-0"
  ],
  [o.BottomStart]: [
    // Spacing
    "mt-0",
    "ml-0"
  ],
  [o.BottomEnd]: [
    // Spacing
    "mt-0",
    "mr-0"
  ],
  [o.Left]: [
    // Spacing
    "mr-0"
  ],
  [o.LeftStart]: [
    // Spacing
    "mr-0",
    "mt-0"
  ],
  [o.LeftEnd]: [
    // Spacing
    "mr-0",
    "mb-0"
  ],
  [o.Right]: [
    // Spacing
    "ml-0"
  ],
  [o.RightStart]: [
    // Spacing
    "ml-0",
    "mt-0"
  ],
  [o.RightEnd]: [
    // Spacing
    "ml-0",
    "mb-0"
  ]
}, j = b({
  name: "OrTooltip",
  components: {
    OrPopover: N
  },
  props: {
    isOpen: {
      type: Boolean,
      default: !1
    },
    content: {
      type: String,
      default: void 0
    },
    placement: {
      type: String,
      default: () => o.Bottom
    },
    fallbackPlacement: {
      type: String,
      default: void 0
    },
    offset: {
      type: [Number, Object, Function],
      default: 8
    },
    debounce: {
      type: Number,
      default: 250
    },
    // Left for backward compatibility since `trigger` prop covers similar tasks in a more neat way
    externalControl: {
      type: Boolean,
      default: !1
    },
    trigger: {
      type: Object,
      default: void 0
    }
  },
  emits: [
    "update:state",
    "open",
    "close"
  ],
  expose: [
    "root",
    "state",
    "open",
    "close",
    "toggle"
  ],
  setup(e, t) {
    e.externalControl && console.warn("Property externalControl is deprecated for OrTooltipV3. Use trigger prop to pass the ref to external control.");
    const l = S(), p = n(() => e.trigger ?? l.value), m = n(() => e.trigger !== void 0 || e.externalControl), i = n(() => [
      "or-tooltip-v3",
      ...V
    ]), s = n(() => [
      "or-tooltip-popover-v3"
    ]), r = n(() => [
      ...w,
      ...L[e.placement]
    ]), { state: u, open: g, close: y, toggle: v } = h(d(e, "isOpen"), t.emit, {
      debounce: d(e, "debounce")
    });
    return {
      root: l,
      localTrigger: p,
      hasExternalControl: m,
      rootStyles: i,
      popoverStyles: s,
      bodyStyles: r,
      state: u,
      open: g,
      close: y,
      toggle: v
    };
  }
});
function M(e, t, l, p, m, i) {
  const s = k("OrPopover");
  return f(), C("div", {
    ref: "root",
    class: a(e.rootStyles),
    onMouseover: t[1] || (t[1] = (r) => !e.hasExternalControl && e.open()),
    onMouseout: t[2] || (t[2] = (r) => !e.hasExternalControl && e.close())
  }, [
    c(e.$slots, "default"),
    e.$slots.content || e.content ? (f(), O(s, {
      key: 0,
      class: a(e.popoverStyles),
      "custom-styles": e.popoverStyles,
      "is-open": e.state === "open",
      variant: "popover",
      trigger: e.localTrigger,
      placement: e.placement,
      "fallback-placement": e.fallbackPlacement,
      offset: e.offset,
      "disable-default-styles": !0,
      "keep-alive": !1,
      "onUpdate:state": t[0] || (t[0] = (r) => r === "open" ? e.open() : e.close())
    }, {
      default: T(() => [
        B("div", {
          class: a(e.bodyStyles)
        }, [
          c(e.$slots, "content", {}, () => [
            P(E(e.content), 1)
          ])
        ], 2)
      ]),
      _: 3
    }, 8, ["class", "custom-styles", "is-open", "trigger", "placement", "fallback-placement", "offset"])) : $("", !0)
  ], 34);
}
const A = /* @__PURE__ */ R(j, [["render", M]]);
export {
  A as O
};
//# sourceMappingURL=OrTooltip-DqwjoE82.mjs.map
